<template>
  <svg viewBox="0 0 20 18"><path fill-rule="nonzero" d="M16.25 0h-13A3.25 3.25 0 000 3.25v8l.005.184A3.25 3.25 0 003.25 14.5H4v2.728l.007.106a.76.76 0 001.25.468L9.03 14.5h7.22a3.25 3.25 0 003.25-3.25v-8A3.25 3.25 0 0016.25 0zm-13 1.5h13c.966 0 1.75.784 1.75 1.75v8A1.75 1.75 0 0116.25 13H8.468L5.5 15.597V13H3.25a1.75 1.75 0 01-1.75-1.75v-8c0-.966.784-1.75 1.75-1.75zm1 2.25h11a.5.5 0 110 1h-11a.5.5 0 010-1zm0 3h11a.5.5 0 110 1h-11a.5.5 0 010-1zm0 3h6a.5.5 0 110 1h-6a.5.5 0 110-1z" /></svg>
</template>

<script>
export default {
  name: 'Edit'
}
</script>
